import React, { FunctionComponent, PropsWithChildren, useCallback } from 'react';
import { useNavigate } from 'react-router';
import classNames from 'classnames';
import UIButton from 'Components/UIComponents/UIButton';
import UIModal from 'Components/UIComponents/UIModal';
import useIsMobile from 'Hooks/Common/useIsMobile';
import { AuthorizedRoutePaths, settingsRedirectionMap } from 'Interfaces/RoutePaths';

export interface UpgradeModalProps {
  title?: string;
  onClose: () => void;
  onUpgradeClick?: () => void;
  cancelComponent?: FunctionComponent;
}

const UpgradeModal = ({
  onClose,
  children,
  title,
  onUpgradeClick,
  cancelComponent: CancelComponent,
}: PropsWithChildren<UpgradeModalProps>) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleUpgrade = useCallback(() => {
    if (onUpgradeClick) {
      onUpgradeClick();
    } else {
      navigate(settingsRedirectionMap[AuthorizedRoutePaths.SETTINGS_BILLING_PLAN]);
    }
  }, [navigate, onUpgradeClick]);

  return (
    <UIModal
      onClose={onClose}
      className={classNames('upgradeModal', { mobile: isMobile })}
    >
      <div className="upgradeModal__inner">
        <div className="upgradeModal__content">
          <h4 className="upgradeModal__title">
            {title || 'Please upgrade your Signaturely account!'}
          </h4>
          <p className="upgradeModal__text">{children}</p>
        </div>
        <UIButton
          priority="primary"
          title="Upgrade Account"
          handleClick={handleUpgrade}
        />
        {CancelComponent && <CancelComponent />}
      </div>
    </UIModal>
  );
};

export default UpgradeModal;
